import axios from "axios";

export default{
    datahelp() {
        return axios.get("/Admin/System/GetLoginPageConfigAdmin");
      },
    savedataHelp(data) {
        return axios.put('Admin/System/UpdateLoginPageConfig', data)
    },
    getContactPublic(){
        return axios.get("/Admin/System/GetLoginPageConfig");

    }

}